// @ts-check
import React from "react"
import Chip from "../atoms/misc/Chip.atom"
import useClientColorsContext from "../../hooks/contextConsumers/useClientColorsContext.hook"
import { backwardCompatibleClientProjectLabel } from "../../utils/strings.utils"

/** @type {import('./ClientChip.molecule.types')["ClientChipMolecule"]} */
const ClientChip = ({
  clientCode,
  labelClassname = "my-0 overflow-hidden text-overflow-ellipsis white-space-nowrap",
  className = "",
  ...props
}) => {
  if (!clientCode) return null
  const { colors } = useClientColorsContext()
  const client = colors.find((client) => client.code === clientCode)

  return (
    <Chip
      className={`client-chip text-white ${className}`}
      template={
        <>
          <div
            className="bg-color"
            style={{ backgroundColor: client?.color }}
          ></div>
          <span
            className={labelClassname}
            style={{ fontSize: "12px", maxWidth: "5ch" }}
            title={clientCode?.length > 3 ? clientCode : ""}
          >
            {backwardCompatibleClientProjectLabel(clientCode)}
          </span>
        </>
      }
      {...props}
      style={{ ...props.style }}
    />
  )
}

export default ClientChip
